import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SpeakingSample from '../components/SpeakingSample';

export default function SpeakingSamplePage() {
  return (
    <>
      <Navbar />
      <SpeakingSample />
      <Footer />
    </>
  );
}
